var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPharmacyFilterGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 1C0.5 0.447715 0.947715 0 1.5 0H13.5C14.0523 0 14.5 0.447715 14.5 1V4C14.5 4.26522 14.3946 4.51957 14.2071 4.70711L9.5 9.41421V13C9.5 13.2652 9.39464 13.5196 9.20711 13.7071L7.20711 15.7071C6.92111 15.9931 6.49099 16.0787 6.11732 15.9239C5.74364 15.7691 5.5 15.4045 5.5 15V9.41421L0.792893 4.70711C0.605357 4.51957 0.5 4.26522 0.5 4V1Z",
    fill: "#4DB181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacyFilterGreen);
export default __webpack_public_path__ + "static/media/pharmacy_filter_green.4b996cc4.svg";
export { ForwardRef as ReactComponent };